module.exports = __webpack_public_path__ + "img/antes_despues_155.e91273fb.png";